import React from 'react';
import { Link, useLocation } from 'react-router-dom'; // Importamos useLocation y Link
import { logo, numVentasPrincipal } from '../config/constant';
import { constructorWhatsapp } from '../utils/utils';

const Header = () => {
  const location = useLocation();
  
  // Evaluamos si el usuario se encuentra exactamente en la raíz de la página
  const isHome = location.pathname === '/';

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md border-b border-slate-100 transition-all">
      <div className="max-w-7xl mx-auto px-6 lg:px-16 h-20 flex items-center justify-between">
        
        {/* LADO IZQUIERDO: LOGO (Siempre regresa al Home de golpe) */}
        <Link to="/" className="flex items-center gap-3 group select-none">
          <img 
            src={logo} 
            alt="Logo Dufy Asesorías" 
            className="w-10 h-10 object-contain transition-transform group-hover:scale-105 duration-300"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />

          <div className="flex flex-col text-left">
            <span className="font-black text-xl tracking-tight text-slate-900 leading-none">
              Dufy<span className="text-blue-600">Asesorías</span>
            </span>
            <span className="text-[10px] text-slate-400 font-bold tracking-wide mt-1">
              #Nosotros lo hacemos por ti
            </span>
          </div>
        </Link>

        {/* CENTRO: NAVEGACIÓN INTELIGENTE (Cambia según la URL) */}
        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-slate-600">
          {isHome ? (
            <>
              {/* MENÚ EN EL HOME: Desplazamiento por anclas internas */}
              <a href="#hero" className="hover:text-blue-600 transition-colors">Inicio</a>
              <a href="#services" className="hover:text-blue-600 transition-colors">Servicios</a>
              <a href="#comoTrabajamos" className="hover:text-blue-600 transition-colors">Cómo funciona</a>
              <a href="#testimonials" className="hover:text-blue-600 transition-colors">Testimonios</a>
            </>
          ) : (
            <>

            </>
          )}
        </nav>

        {/* LADO DERECHO: BOTÓN DE ACCIÓN PRIORITARIA */}
        <div>
          <a 
            href={constructorWhatsapp(numVentasPrincipal, "Hola, tengo un requerimiento académico urgente.")}            
            target="_blank"
            rel="noopener noreferrer"
            className="bg-rose-600 hover:bg-rose-700 text-white font-extrabold text-xs px-5 py-2.5 rounded-xl shadow-md shadow-rose-600/10 transition-all transform hover:-translate-y-0.5 inline-flex items-center gap-2.5"
          >
            {/* Punto con efecto de latido en vivo */}
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
            </span>
            <span>Urgente</span>
          </a>
        </div>

      </div>
    </header>
  );
};

export default Header;